import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import cookie from "js-cookie";
import { DatePicker } from "react-advance-jalaali-datepicker";
import ExportJsonExcel from "js-export-excel";
import moment from "moment";
import categoryUserSitePublisherAction from "../../../../../store/actions/categoryUserSitePublisher";
import httpService from "../../../../../services/httpServices/httpServices";
import Pagination from "../../../../partials/content/Pagination";
import validateFormPermission from "../../../../../validtions/forms/category-user-site-publishers/add-categories-user-site-publishers";
import typeGroupSitePublisher from "./../../TypeGroupSitePublisher";
import messageCategoryUserSitePublishers from "../../../../../messages/category-user-site-publishers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";
import typeActionCategoryUserSitePublisher from "../../../../../store/actions/typeActionCategoryUserSitePublisher";
import actionCookie from "../../../../../helpers/action-cookie";
import SelectDropDown from "../../../../partials/content/SelectDropDown";
import Sidebar from "../../../../partials/aside/Sidebar";

function AddGroupSitePublisher({
  dataSitePublisher,
  render,
  emptyPositions,
  setDates,
  startDate,
  endDate,
  nameCategory,
  resetDate,
  setTypeAction,
}) {
  const [message, setMessage] = useState();

  const [categoriesSitePublisher, setCategoriesSitePublisher] = useState([]);
  const [sitesPublisher, setSitesPublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [siteNameSearchFilter, setSiteNameSearchFilter] = useState();
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);

  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers/") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };

  const [isShowWebSite, setIsShowWebSite] = useState(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      startDate = null;
      endDate = null;
    }
    if (startDate !== null && endDate !== null) {
      return true;
    }

    return false;
  });

  if (!startDate) {
    startDate = moment(helpersTime.getDateNow())
      .add(1, "days")
      .format("YYYY/M/D");
  }

  if (!endDate) {
    endDate = moment(helpersTime.getDateNow())
      .add(2, "days")
      .format("YYYY/M/D");
  }

  setTypeAction({
    type_action: typeActionCategoryUserSitePublisher.ADD,
  });

  const typeAdvertisePublisher = "banner";
  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (categoriesSitePublisher.length > 0) {
      return;
    }
    getCategoriesSitesPublisher();
  }, []);

  useEffect(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      resetDate();
      emptyPositions();
    }
  }, []);

  useEffect(() => {
    getSitesPublisher();
  }, [currentPage, siteNameSearchFilter, categoryNameSearchFilter]);

  const getCategoriesSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategoryAllPublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categories) {
      return;
    }
    setCategoriesSitePublisher(categories);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (siteNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&site=${siteNameSearchFilter}`;
    }
    if (categoryNameSearchFilter) {
      if (categoryNameSearchFilter != "همه دسته ها") {
        searchFilterQuery = `${searchFilterQuery}&category=${categoryNameSearchFilter}`;
      }
    }

    return searchFilterQuery;
  };

  const getSitesPublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitesPublisher = await sendRequestSitesPublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!sitesPublisher) {
      return;
    }

    setSitesPublisher(sitesPublisher.data);
    setCountPage(sitesPublisher.total_page);
  };

  const generateTagSitesPublisher = () => {
    return (
      <>
        <div className="col-12 pb-3">
          <div className="table-responsive pt-3">
            <table className="table table-hilite tbl-td-white-space table-hover">
              <thead>
                <tr>
                  <td>#</td>
                  <td>نمایش دهنده</td>
                  <td>دسته بندی موضوع</td>
                  <td>قابل نمایش در</td>
                  <td>نمایش صفحات</td>
                </tr>
              </thead>
              <tbody>
                {sitesPublisher.map((sitePublisher, index) => {
                  return (
                    <tr key={index}>
                      <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                      <td>
                        <a href={sitePublisher.url} target="_blank">
                          {sitePublisher.url}
                        </a>
                      </td>
                      <td>{sitePublisher.categories.join(" - ")}</td>
                      <td>
                        <div className="d-flex justify-content-around">
                          <span>
                            <i className="fa fa-mobile-alt"></i>
                          </span>
                          <span>
                            <i className="fa fa-desktop"></i>
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span>
                            <Link
                              to={`/manage/publishers/alternative/${sitePublisher.id}/all-page`}
                              className="btn btn-info"
                            >
                              جایگاه های نمایش تبلیغات
                            </Link>
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
          {countPage > 1 && generatePagination()}
        </div>
      </>
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePagination = () => {
    return (
      <Pagination
        countPage={countPage}
        currentPage={currentPage}
        paginationItemOnClickHandler={paginationItemOnClickHandler}
      />
    );
  };

  const sendRequestSitesPublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let sitePublishers;
    try {
      sitePublishers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/site-publishers?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return sitePublishers.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const sendRequestGetCategoryAllPublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    if (validateFormPermission(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormPermission(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddCategoryUserSitePublisher =
      await sendRequestAddCategoryUserSitePublisher(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddCategoryUserSitePublisher) {
      return;
    }
    emptyPositions();
    history.push(
      "/manage/publishers/all-banner-category-site-publisher-alternative"
    );
  };

  const sendRequestAddCategoryUserSitePublisher = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-user-site-publishers/alternative",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return false;
    }

    return true;
  };

  const getDataForm = () => {
    const typeGroupPublisher = typeGroupSitePublisher.getTypeGroupPublisher(
      typeAdvertisePublisher
    );
    startDate = helpersTime.convertJalaliToGregorian(startDate);
    endDate = helpersTime.convertJalaliToGregorian(endDate);
    return {
      name: document.getElementById("name").value.trim(),
      type_id: "" + typeGroupPublisher,
      amount: getPriceCategoryUserSitePublisher(dataSitePublisher) + "",
      start_date: startDate,
      end_date: endDate,
      sites: dataSitePublisher,
    };
  };

  const exportReportExcel = () => {
    const newDataSitePublisher = { ...dataSitePublisher };
    var option = new Object();
    const categoryUserSitePublisher = document
      .querySelector("#name")
      .value.trim();
    option.fileName =
      categoryUserSitePublisher == ""
        ? "گزارش سایت های انتخاب شده"
        : categoryUserSitePublisher;
    let dataExcelFile = [
      {
        one: "مبلغ گروه نمایش دهنده",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(newDataSitePublisher)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(startDate),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(endDate),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];

    for (let key in newDataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          newDataSitePublisher[key]
        ),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherDataParam
  ) => {
    let sitePublisherUrl = sitePublisherDataParam.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherDataParam)
          )
        ),
      },
    ];

    for (const key in sitePublisherDataParam) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherDataParam[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }

    return dataEachSitePublisherExcelFile;
  };

  const showSelectCategorySitePublisher = () => {
    let categoriesSitesPublishersForDropDown = categoriesSitePublisher.map(
      (category) => {
        return { value: category.id, label: category.name };
      }
    );

    categoriesSitesPublishersForDropDown = [
      { value: 0, label: "همه دسته ها" },
      ...categoriesSitesPublishersForDropDown,
    ];

    return (
      <SelectDropDown
        data={categoriesSitesPublishersForDropDown}
        setItemHandler={(newItemSelected) => {
          setCategoryNameSearchFilter(newItemSelected.label);
        }}
      />
    );
  };

  const generatePageDataReportExportExcel = (pageDataReport) => {
    return [
      {
        one: pageDataReport.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(pageDataReport.price)
        ),
      },
      { ...pageDataReport.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const checkStartDateEntered = (startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    if (moment(startDateEntered).diff(startDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_PAST_FROM_CURRENT_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(startDateEntered).diff(currentDate, "days");
    let maxCountDaysCategoryUserSitePublisherForStartDate =
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      ) - 1;
    if (differentDates > maxCountDaysCategoryUserSitePublisherForStartDate) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });

      return false;
    }

    return true;
  };

  const checkEndDateEntered = (endDateEntered, startDateEntered) => {
    endDateEntered = helpersTime.convertJalaliToGregorian(endDateEntered);

    if (moment(endDateEntered).diff(endDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      moment(endDateEntered).diff(
        moment(helpersTime.convertJalaliToGregorian(startDateEntered)),
        "d"
      ) < 0
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(endDateEntered).diff(currentDate, "days");
    if (
      differentDates >
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const showWebSites = (e) => {
    e.preventDefault();
    const startDateEntered = document.querySelector(".start-date input").value;
    const endDateEntered = document.querySelector(".end-date input").value;
    const nameCategory = document.querySelector("#name").value.trim();
    if (!checkStartDateEntered(startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }
    if (!checkEndDateEntered(endDateEntered, startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    setDates({
      name_category: nameCategory,
      start_date: startDateEntered,
      end_date: endDateEntered,
    });
    setIsShowWebSite(true);
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1
                  className="px-5 py-1  bg-warning"
                  style={{ fontSize: "15px" }}
                >
                  اضافه کردن گروه نمایش دهنده بنری جایگزین با انتخاب جایگاه
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div id="add-group-site-publisher">
                {messageTag}
                <form onSubmit={sendForm}>
                  <div className="form-group">
                    <label>نام گروه</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="نام گروه"
                      id="name"
                      defaultValue={nameCategory != null ? nameCategory : ""}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <div className="container-fluid p-0">
                      <div className="row align-items-end">
                        {isShowWebSite ? (
                          <div className="col-12">
                            <div className="table-responsive pt-3">
                              <table className="table table-hilite">
                                <thead>
                                  <tr>
                                    <td className="text-nowrap">
                                      ارزش یک شبانه روز گروه نمایش دهنده{" "}
                                    </td>
                                    <td>تاریخ شروع </td>
                                    <td>تاریخ پایان </td>
                                    <td> دریافت لیست گروه بنری </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <span className="px-2 letter-spacing-finance-number">
                                        {helpersNumbers.toPersianNum(
                                          helpersNumbers.toFormatFinanceNumber(
                                            getPriceCategoryUserSitePublisher(
                                              dataSitePublisher
                                            )
                                          )
                                        )}
                                      </span>
                                      <span className="pr-2">تومان</span>
                                    </td>
                                    <td>
                                      <span className="number-finance">
                                        {helpersNumbers.toPersianNum(startDate)}
                                      </span>
                                    </td>
                                    <td>
                                      <span className="number-finance">
                                        {helpersNumbers.toPersianNum(endDate)}
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        className="btn btn-success"
                                        onClick={exportReportExcel}
                                      >
                                        <span className="pl-2">
                                          <i className="fa fa-file-excel"></i>
                                        </span>
                                        <span>خروجی فایل Excel</span>
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="col-12 col-md-4 pb-3">
                              <div>
                                <div>
                                  <label>تاریخ شروع</label>
                                </div>
                                <div className="custom-data-picker start-date">
                                  {isShowWebSite ? (
                                    <></>
                                  ) : (
                                    <DatePicker
                                      placeholder="انتخاب تاریخ"
                                      format="jYYYY/jMM/jDD"
                                      preSelected={helpersTime.convertGregorianToJalali(
                                        startDate
                                      )}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-md-4 pb-3">
                              <div>
                                <div>
                                  <label>تاریخ پایان</label>
                                </div>
                                <div className="custom-data-picker end-date">
                                  {isShowWebSite ? (
                                    <></>
                                  ) : (
                                    <DatePicker
                                      placeholder="انتخاب تاریخ"
                                      format="jYYYY/jMM/jDD"
                                      preSelected={helpersTime.convertGregorianToJalali(
                                        endDate
                                      )}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-12 col-md-4 pb-3">
                          {isShowWebSite ? (
                            <></>
                          ) : (
                            <button
                              className="btn btn-success w-100"
                              onClick={showWebSites}
                              disabled={isShowWebSite ? "disabled" : ""}
                            >
                              اعمال تاریخ و نمایش سایت ها
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className={`container-fluid p-0 ${
                        isShowWebSite ? "" : "d-none"
                      } `}
                    >
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div>
                            <label>جستجو آدرس سایت</label>
                          </div>
                          <div>
                            <input
                              className="form-control"
                              id="site"
                              type="text"
                              onKeyUp={(e) => {
                                setSiteNameSearchFilter(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6">
                          <div>
                            <div>
                              <label>
                                دسته بندی نمایش دهنده های مرتبط (برای شما)
                              </label>
                            </div>
                            <div>{showSelectCategorySitePublisher()}</div>
                          </div>
                        </div>

                        {sitesPublisher.length == 0 &&
                        siteNameSearchFilter == null &&
                        categoryNameSearchFilter == null ? (
                          <></>
                        ) : (
                          generateTagSitesPublisher()
                        )}
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <button type="submit" className="btn btn-success">
                            اضافه کردن
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    render: state.categoryUserSitePublisher.render,
    nameCategory: state.categoryUserSitePublisher.name_category,
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyPositions: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.EMPTY_POSITION,
        payload: action,
      });
    },
    setDates: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_DATE,
        payload: action,
      });
    },
    setTypeAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_TYPE_ACTION,
        payload: action,
      });
    },
    resetDate: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_DATE,
        payload: action,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddGroupSitePublisher);
